import useSWRImmutable from "swr/immutable";
import {useSelector} from "react-redux";

const fetcher = (url: string) => fetch(url).then((res) => res.json());
const useCaBanks = () => {
    const country = useSelector<any, string>((state)=>state.settings.country);

    const { data, isLoading } = useSWRImmutable(
        country === "CA"
            ? "/ca-financial-institutions.json"
            : null,
        fetcher
    );

    return data;

}
export default useCaBanks;